<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/launch-page-activity/table">活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="活动名称"
                          prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item prop="content"
                          label="活动描述">
              <wang-editor
                v-model="form.content"
                :menus="['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','undo','redo']"
                :colors="['#f3605b', '#333']">
              </wang-editor>
            </el-form-item>

            <el-form-item prop="starttime"
                          label="活动开始时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.starttime"
                type="datetime"
                placeholder="请选择活动开始时间"
                align="center">
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="endtime"
                          label="活动结束时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.endtime"
                type="datetime"
                placeholder="请选择活动结束时间"
                align="center">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="跳过时间"
                          prop="skip_time">
              <el-col span="10">
                <el-input v-model="form.skip_time">
                  <template slot="append">秒</template>
                </el-input>
              </el-col>

            </el-form-item>

            <el-form-item label="添加链接"
                          prop="activity_url">
              <el-input v-model="form.activity_url"></el-input>
            </el-form-item>

            <el-form-item prop="img_url"
                          label="上传图片">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="onChangeFile"
                         :on-remove="handleRemove"
              >
                <img v-if="form.img_url"
                     :src="form.img_url"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span class="color-info"
                    style="font-size: 12px;line-height: 40px;">只能上传jpg/jpeg/png文件，且不超过5M</span>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import WangEditor from '@components/WangEditorV3Deprecated'

export default {
  components: {WangEditor},
  data () {
    return {
      id: 0,
      formRules: {
        title: [
          {required: true, message: '活动名称不能为空', trigger: 'blur'},
          {min: 2, max: 16, message: '活动名称长度应为2到16个字符', trigger: 'blur'},
        ],
        starttime: [
          {required: true, message: '活动开始时间不能为空', trigger: 'blur'},
        ],
        endtime: [
          {required: true, message: '活动结束时间不能为空', trigger: 'blur'},
          {validator: this.endtimeValidator, trigger: 'blur'},
        ],
        skip_time: [
          {required: true, message: '跳过时间不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        activity_url: [
          {required: true, message: '活动添加链接不能为空', trigger: 'blur'},
        ],
        img_url: [
          {required: true, message: '上传图片不能为空', trigger: 'blur'},
        ],
      },
      form: {
        title: '',
        content: '',
        skip_time: '',
        starttime: '',
        endtime: '',
        activity_url: '',
        img_url: '',

      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getLaunchPageActivityDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createLaunchPageActivityData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/launch-page-activity/table/'})
        })
      })
    },
    update (id) {
      request.common('updateLaunchPageActivityData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/launch-page-activity/table/'})
        })
      })
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw)
    },
    onUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadFair', formData).then(({data}) => {
        this.form.img_url = data
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    handleRemove (file, fileList) {
      this.form.img_url = ''
    },
    // 验证活动结束时间
    endtimeValidator (rule, value, callback) {
      if (Date.parse(this.form.endtime) <= Date.parse(this.form.starttime)) {
        callback(new Error('活动结束时间必须晚于活动开始时间'))
      } else {
        callback()
      }
    },

    positiveIntegerValidator (rule, value, callback) {
      if (value && (!Number.isInteger(Number(value)) || Number(value) <= 0)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    },

  },
}
</script>
<style lang="scss">
// 全局CSS

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.el-icon-plus:before {
  line-height: 178px;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style lang="scss"
       scoped>

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html

</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/launch-page-activity/pages/LaunchPageActivityForm.vue